<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>{{ 'posManager.addCustomPrice' | transloco }}</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">{{ 'common.close' | transloco }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <pos-numeric-keyboard (onValueChange)="amount = $event"
                        (submitEvent)="onSave()"
                        [buttons]="[]"></pos-numeric-keyboard>
</ion-content>
<ion-footer>
  <ion-toolbar mode="md"
               color="light">
    <ion-buttons slot="end">
      <ion-button mode="md"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onSave()">{{ 'posManager.savePrice' | transloco | uppercase }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
